module.exports = __webpack_public_path__ + "static/livechat-464b15a33958d88a8aa277ee4b3d7523.png";